import { morphism } from 'morphism';

import { contactRequest, contactResponse } from '@hero/schemas';

import { api } from './api';
import { endpoints } from './endpoints';

const bulkUpsertContact = requestData => {
  const _contacts = morphism(contactRequest.bulkUpsert, requestData);

  return api.post(endpoints.bulkUpsertContact(), _contacts).then(res => {
    return res.data.data;
  });
};

const createContact = params =>
  api.post(endpoints.contacts(), params).then(res => {
    return morphism(contactResponse.updateContact, res.data.data);
  });

const createTag = tags =>
  api.post(endpoints.listTags(), tags).then(res => {
    return morphism(contactResponse.createTag, res.data.data);
  });

const getContact = (contactId, params) =>
  api.get(`${endpoints.contacts()}/${contactId}`, { params }).then(res => {
    return morphism(contactResponse.getContact, res.data.data);
  });

const getContacts = params =>
  api
    .post(endpoints.listContacts(), morphism(contactRequest.listContact, params))
    .then(res => morphism(contactResponse.listContact, res.data.data));

const listTags = params =>
  api.get(endpoints.listTags(), { params }).then(res => {
    return morphism(contactResponse.listTags, res.data.data);
  });

const removeContactTags = requestData =>
  api.put(endpoints.contactRemoveTags(), requestData).then(res => {
    return morphism(contactResponse.createTag, res.data.data);
  });

function removeContact(id) {
  return api.delete(endpoints.contactDetail(id)).then(res => {
    return res.data.data;
  });
}

const selectAll = params =>
  api.get(endpoints.selectAll(), { params }).then(res => {
    return morphism(contactResponse.selectAll, res.data.data);
  });

const selectAllTags = params =>
  api.get(endpoints.selectAllTags(), { params }).then(res => {
    return morphism(contactResponse.listTags, res.data.data);
  });

const updateContact = (id, params) => {
  const body = morphism(contactRequest.update, params);

  return api
    .put(`${endpoints.contacts()}/${id}`, body)
    .then(res => morphism(contactResponse.updateContact, res.data.data));
};

const updateContactTags = body =>
  api.put(endpoints.contactAddTags(), body).then(res => {
    return morphism(contactResponse.createTag, res.data.data);
  });

const updateTagContacts = (id, body) =>
  api.put(endpoints.updateTagContacts(id), body).then(res => {
    return morphism(contactResponse.createTag, res.data.data);
  });

function removeTag(id) {
  return api.delete(endpoints.tagDetail(id)).then(res => {
    return res.data.data;
  });
}

export {
  bulkUpsertContact,
  createContact,
  createTag,
  getContact,
  getContacts,
  listTags,
  removeContact,
  removeContactTags,
  removeTag,
  selectAll,
  selectAllTags,
  updateContact,
  updateContactTags,
  updateTagContacts
};
